<a [routerLink]="['/my-patients']" routerLinkActive="active">
  <span class="text">{{'Мои пациенты' | translate}}</span>
</a>
